__turbopack_context__.v({
  "carouselHeader": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselHeader",
  "carouselNav": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselNav",
  "carouselNavBtn": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselNavBtn",
  "carouselNavIconNext": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselNavIconNext",
  "carouselNavIconPrev": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselNavIconPrev",
  "carouselSlide": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselSlide",
  "carouselSlideInner": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselSlideInner",
  "carouselSwiper": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselSwiper",
  "carouselTitle": "TasksComingSoon-module-scss-module__Jlt7Zq__carouselTitle",
  "section": "TasksComingSoon-module-scss-module__Jlt7Zq__section",
});
